import servise from '@/router/axios'

export const auditApp = (data) => {
  return servise({
    url: '/app/channel/report',
    method: 'PUT',
    data
  })
}
